import Ecological from './Pages/ecological';
import Login from './Pages/login';
import Signup from './Pages/Signup';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from './Pages/DashboardModern';
import Lake from './Pages/Lake';
import LakeDashboardModern from './Pages/LakeDashboardModern';
import YearlyChart from './Components/Chart/Statuschart';
import Contractor from './Pages/VendorModern';
import Agreement from './Pages/AgreementModern';
import MapPage from './Components/Map/Map';
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./firebase/protectedroute";
import UsersPage from './Pages/UserModern';
import WorkflowTemplates from './Pages/WorkflowTemplates';
import { AuthProvider } from './contexts/AuthContext'; // ✅ fixed import
import Profile from './Pages/ProfileModern';
import CommonPageTemplate from './Components/common_template';
import TaskManagement from './Components/Task/TaskManagement';
import Maintenance from './Pages/Maintenance';
import TaskDashboard from './Pages/TaskDashboard';
import Sites from './Pages/SiteModern';
import Mapedit from './Components/Map/Mapedit';
import Sla from './Pages/SLAModern';
import { AuthDataProvider } from './contexts/AuthDataContext';
import { OrgProvider } from './contexts/OrgContext';
import { PermissionProvider } from './contexts/PermissionContext';
import Department from './Pages/DepartmentModern';
import RolesWithPermissions from './Pages/RolesWithPermissions';
import ContractType from "./Pages/ContractTypeModern";
import GeoJSONUploadModern from './Pages/GeoJSONUploadModern';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import LayoutWrapper from './Components/LayoutWrapper';
import Onboarding from './Pages/Onboarding';
import './styles/index.css';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AuthDataProvider>
          <OrgProvider>
            <PermissionProvider>
              <Router>
                <Routes>
                  {/* Public routes */}
                  <Route path='/login' element={<Login />} />
                  <Route path='/signup' element={<Signup />} />
                  <Route path='/map' element={<MapPage />} />
                  <Route path="/map-edit" element={<Mapedit />} />

                  {/* Onboarding route - accessible without organization */}
                  <Route path='/onboarding' element={
                    <ProtectedRoute allowWithoutOrg>
                      <Onboarding />
                    </ProtectedRoute>
                  } />

                  {/* Protected routes with layout */}
                  <Route path='/' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Dashboard /></LayoutWrapper>
                    </ProtectedRoute>
                  } />
                  
                  <Route path='/profile' element={
                    <ProtectedRoute contractorAllowed>
                      <LayoutWrapper><Profile /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/dashboard' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Dashboard /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/lakedashboard' element={
                    <ProtectedRoute>
                      <LayoutWrapper><LakeDashboardModern /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/users' element={
                    <ProtectedRoute>
                      <LayoutWrapper><UsersPage /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/departments' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Department /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/roles' element={
                    <ProtectedRoute>
                      <LayoutWrapper><RolesWithPermissions /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/contracttype' element={
                    <ProtectedRoute>
                      <LayoutWrapper><ContractType /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/sla' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Sla /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/sites' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Sites /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/lake' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Lake /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/contractor' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Contractor /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/agreement' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Agreement /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/ecological' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Ecological /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/workflows' element={
                    <ProtectedRoute>
                      <LayoutWrapper><WorkflowTemplates /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/taskmanagement' element={
                    <ProtectedRoute contractorAllowed>
                      <LayoutWrapper><TaskManagement /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/maintenance' element={
                    <ProtectedRoute>
                      <LayoutWrapper><Maintenance /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/taskdashboard' element={
                    <ProtectedRoute>
                      <LayoutWrapper><TaskDashboard /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/pagetemplate' element={
                    <ProtectedRoute>
                      <LayoutWrapper><CommonPageTemplate /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/upload-trees' element={
                    <ProtectedRoute>
                      <LayoutWrapper><GeoJSONUploadModern /></LayoutWrapper>
                    </ProtectedRoute>
                  } />

                  <Route path='/statuschart' element={<LayoutWrapper><YearlyChart /></LayoutWrapper>} />

                  {/* Fallback */}
                  <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
                <ToastContainer />
              </Router>
            </PermissionProvider>
          </OrgProvider>
        </AuthDataProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
